import React from 'react';

export default function FlipText({ children, className = '', duration = 2.4, delay = 0, loop = true, gradient = false }) {
  const words = children.split(' ');
  const total = children.replace(/ /g, '').length;
  let n = 0;

  return (
    <span className={`ob-flip ${gradient ? 'ob-flip--gradient' : ''} ${className}`} aria-label={children} role="img">
      {words.map((word, wi) => (
        <span key={wi} className="ob-flip__word" aria-hidden="true">
          {word.split('').map((ch, ci) => {
            const i = n++;
            const d = Math.sin((i / total) * (Math.PI / 2)) * duration * 0.25 + delay;
            return (
              <span
                key={ci}
                className="ob-flip__char"
                style={{
                  '--flip-duration': `${duration}s`,
                  '--flip-delay': `${d}s`,
                  '--flip-iteration': loop ? 'infinite' : '1',
                  '--i': i,
                  '--n': total,
                }}
              >
                {ch}
              </span>
            );
          })}
          {wi < words.length - 1 && <span className="ob-flip__space">&nbsp;</span>}
        </span>
      ))}
    </span>
  );
}
